import createClient from 'openapi-fetch';
import { API_URL } from '../config';
import type { paths } from './schema';
import { session } from './session';

/**
 * Adds the access token to a request. If the answer is 401 (token expired), refreshes the session once
 * and retries; a second 401 means the user must sign in again.
 */
export async function authorisedFetch(request: Request): Promise<Response> {
  const retry = request.clone();
  const response = await fetch(withToken(request));
  if (response.status !== 401) return response;
  if (!(await session.refresh())) return response;
  return fetch(withToken(retry));
}

function withToken(request: Request): Request {
  const token = session.get().accessToken;
  if (!token) return request;
  const headers = new Headers(request.headers);
  headers.set('Authorization', `Bearer ${token}`);
  return new Request(request, { headers });
}

/** Typed client for every signed-in call; types are generated from the backend (pnpm gen:api). */
export const api = createClient<paths>({ baseUrl: API_URL, credentials: 'include', fetch: authorisedFetch });
